import React from 'react';

function Message() {
  return (
    <svg
      width="22"
      height="22"
      className="fill-current"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M19.735.082H2.265A2.18 2.18 0 00.093 2.265L.082 21.918l4.367-4.367h15.286a2.19 2.19 0 002.183-2.184V2.265A2.19 2.19 0 0019.735.082zm-6.286 13.102h-9V11h9v2.184zm4.102-3.276H4.449V7.725h13.102v2.183zm0-3.275H4.449V4.449h13.102v2.184z" />
    </svg>
  );
}

export default Message;
